import styled from 'styled-components';

/* ----------------------------------
   Subscription
----------------------------------- */

export const SubscriptionCallout = styled.section`
  width: 100%;

  overflow: hidden;

  border: 1px solid rgba(230, 139, 7, 0.16);
  border-radius: var(--borderRadiusLarge);

  background: linear-gradient(135deg, var(--yellow1) 0%, var(--orange7) 100%);

  box-shadow: var(--shadow-sm);
`;

export const SubscriptionAccent = styled.div`
  padding: var(--space-s) var(--space-xl);

  background: var(--yellow4);

  span {
    color: var(--grey7);

    font-size: 0.72rem;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.1em;
  }
`;

export const SubscriptionContent = styled.div`
  padding: var(--space-xxl);

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-xxl);

  h2 {
    margin: var(--space-xs) 0 var(--space-m);

    color: var(--grey7);

    font-size: clamp(1.8rem, 3vw, 2.7rem);
    line-height: 1.05;
    font-weight: 900;
  }

  p:not(.eyebrowHeader) {
    max-width: 720px;

    margin: 0;

    color: var(--grey4);

    font-size: 0.95rem;
    line-height: 1.75;
  }

  @media screen and (max-width: 850px) {
    align-items: flex-start;
    flex-direction: column;
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-xl);
  }
`;
